import type FolderTreeType from './schema/FolderTreeType';
import type FolderViewStateStore from './schema/FolderViewStateStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

const initialFolderViewStateStore: FolderViewStateStore = {
    showFolderPane: false,
    showMoveToFolderPane: false,
    orderedFavoritesFolderIds: [],
    folderNodeViewStates: new ObservableMap({}),
    moveToFolderNodeViewStates: new ObservableMap({}),
    selectedFolderTree: 0,
    perfDatapoint: null,
};

export const getStore = createStore<FolderViewStateStore>(
    'folderViewState',
    initialFolderViewStateStore
);

const store = getStore();
export default store;
